import { defineComponent, onBeforeMount } from 'vue';
import LogOut from '@/stand-alone/log-out/log-out.vue';
import ErrorModal from '@/presentation/components/shared/error-modal/error-modal.vue';
import OverlappingCampaignsModal from '@/presentation/components/shared/overlapping-campaigns-modal/overlapping-campaigns-modal.vue';
import UnsafeExitModal from '@/presentation/components/shared/unsafe-exit-modal/unsafe-exit-modal.vue';
import NotificationStatus from '@/presentation/components/shared/notification-status/notification-status.vue';
import NavigationBar from '@/presentation/components/shared/navigation-bar/navigation-bar.vue';
import SaveBlock from '@/presentation/components/shared/save-block/save-block.vue';
import TitleBlock from '@/presentation/components/shared/title-block/title-block.vue';
import TopHeader from '@/presentation/components/shared/top-header/top-header.vue';
import AppCode from '@/presentation/app.code';

export default defineComponent({
	components: {
		LogOut,
		ErrorModal,
		OverlappingCampaignsModal,
		UnsafeExitModal,
		NavigationBar,
		NotificationStatus,
		SaveBlock,
		TitleBlock,
		TopHeader
	},
	setup: () => {
		const code = new AppCode();

		onBeforeMount(code.mounted.bind(code));

		return {
			CurrentComponent: code.CurrentComponent,
			standAloneLogin: code.standAloneLogin,
			errorActive: code.errorActive,
			unsafeExitActive: code.unsafeExitActive,
			notificationActive: code.notificationActive,
			isLoading: code.isLoading,
			isOverlap: code.isOverlap,
			isCampaignCreation: code.isCampaignCreation
		};
	}
});
